import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GenericService } from "src/app/commons/generic.service";
import { TribunalOrigem } from "src/app/model/tribunalOrigem";

@Injectable()
export class TribunalOrigemService extends GenericService {
  private relativePath = "api/tribunal-origem";
  listaTribunais: Observable<string>;

  constructor(http: HttpClient) {
    super(http);
  }

  obterListaTribunais(): Observable<Array<TribunalOrigem>> {
    return this.http.get<Array<TribunalOrigem>>(this.url + this.relativePath + `/find-all`);
  }
}
